import { MenuItems } from "../pages/menuItems";
import BeachComberLogo from "../../Img/cms/beach-comber-logo.svg";
import BeachComberFooterLogo from "../../Img/cms/beach-comber-footer-logo.svg";
import { Page } from "../../Components/pages/objects/page";

const Header: Page['header'] = {
    logo: BeachComberLogo,
    transparentLogo: BeachComberFooterLogo,
    infoText: {
        content: [
            {
                locale: 1,
                value: `
                    RESERVATION<br />
                    De France : +33(0)1 44 94 72 72
                    <br />
                    De Belgique : +32(0)2 616 67 18
                `
            },
            {
                locale: 2,
                value: `
                    Call center: +32(0) 688 700 70
                    <br />
                    booking@beachcombertours.be
                `
            }
        ]
    },
    menu: {
        links: MenuItems
    }
}

export default Header;